import {
  combine, createEvent, createStore, sample
} from 'effector';
import { createGate } from 'effector-react';
import { PostcardActionsEvents, sendSaveEventTrigger } from 'src/entity/Analitic';
import { $postCardCanvas, setIsPostCardPreparing } from 'src/entity/PostCard';
import { $isUserUseMobileApp } from 'src/entity/User';
import { downloadPostCardOnDesktopFx } from '../lib/effects/donwloadPostCardOnDesktopFx/donwloadPostCardOnDesktopFx';
import { downloadPostCardOnMobileFx } from '../lib/effects/downloadPostCardOnMobileFx/downloadPostCardOnMobileFx';

export const SavePostCardGate = createGate();

export const setIsSavePostCard = createEvent<boolean>();
export const $isSavePostCard = createStore<boolean>(false);

sample({
  clock: setIsSavePostCard,
  target: $isSavePostCard
});

sample({
  clock: $isSavePostCard,
  filter: $isSavePostCard => $isSavePostCard,
  fn: () => PostcardActionsEvents.SAVE,
  target: sendSaveEventTrigger
});

const $combnedSavePostCardStores = combine({
  $isUserUseMobileApp,
  $postCardCanvas,
  $isSavePostCard
});

sample({
  clock: $postCardCanvas,
  source: $combnedSavePostCardStores,
  filter: ({ $isUserUseMobileApp, $postCardCanvas, $isSavePostCard }) => (
    !$isUserUseMobileApp && !!$postCardCanvas && !!$isSavePostCard
  ),
  fn: ({ $postCardCanvas }) => $postCardCanvas!,
  target: downloadPostCardOnDesktopFx
});

sample({
  clock: $postCardCanvas,
  source: $combnedSavePostCardStores,
  filter: ({ $isUserUseMobileApp, $postCardCanvas, $isSavePostCard }) => (
    !!$isUserUseMobileApp && !!$postCardCanvas && !!$isSavePostCard
  ),
  fn: ({ $postCardCanvas }) => $postCardCanvas!,
  target: downloadPostCardOnMobileFx
});

sample({
  clock: [downloadPostCardOnMobileFx.done, downloadPostCardOnMobileFx.fail],
  fn: () => false,
  target: [setIsPostCardPreparing, setIsSavePostCard]
});

sample({
  clock: [downloadPostCardOnDesktopFx.done, downloadPostCardOnDesktopFx.fail],
  fn: () => false,
  target: [setIsPostCardPreparing, setIsSavePostCard]
});
